import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  canonicallsPathForXoAlias,
  isCanonicallsHost,
  isCanonicallsOwnedPath,
} from "../../lib/canonicallsHost";
import { CanonicallsShellWithSuspense } from "./CanonicallsShell";

export function CanonicallsRouteGate({
  children,
  loadingLabel,
}: {
  children: React.ReactNode;
  loadingLabel?: string;
}) {
  const { pathname, search } = useLocation();
  const hostname =
    typeof globalThis !== "undefined" && "location" in globalThis
      ? (globalThis as unknown as { location: { hostname: string } }).location.hostname
      : "";

  if (isCanonicallsOwnedPath(pathname)) {
    return (
      <CanonicallsShellWithSuspense loadingLabel={loadingLabel}>{children}</CanonicallsShellWithSuspense>
    );
  }

  if (isCanonicallsHost(hostname)) {
    const ccAlias = canonicallsPathForXoAlias(pathname);
    if (ccAlias) {
      return <Navigate to={`${ccAlias}${search}`} replace />;
    }
    return (
      <CanonicallsShellWithSuspense loadingLabel={loadingLabel}>{children}</CanonicallsShellWithSuspense>
    );
  }

  return (
    <CanonicallsShellWithSuspense loadingLabel={loadingLabel}>{children}</CanonicallsShellWithSuspense>
  );
}
